const Loader = () => {
  return (
    <div className="m-auto  border-l-2 rounded-full size-5 animate-spin border-green-500"></div>
  );
};
export default Loader;
